import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class UsageReportApi extends BaseApi {
  async getUsageReportList(
    parameters: APIPaths["/partner-app/usage-report/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/partner-app/usage-report/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (
      await this.get("/partner-app/usage-report/list", {
        params: parameters,
      })
    ).data;
  }
}
